import React from 'react';

const MobileLayout = ({ header, children, bottomNav, overlays, className = '' }) => {
  return (
    <div className={`mobile-layout ${className}`}>
      {header && <div className="mobile-layout__header">{header}</div>}
      <div className="mobile-layout__content">{children}</div>
      {bottomNav && <div className="mobile-layout__bottom">{bottomNav}</div>}
      {overlays}
    </div>
  );
};

export default MobileLayout;
